module.exports = __webpack_public_path__ + "static/img/google-play-badge.4794c5cf.svg";